const initialState = {
  count: 0,
  data: undefined,
  errorMessage: null,
  isLoading: false,
  isFulfilled: false,
  isRejected: false,
};

export const GetListUsersData = (state = initialState, action) => {
  switch (action.type) {
    case "GET_LIST_USER_PENDING":
      return {
        ...state,
        isLoading: true,
        isRejected: false,
        isFulfilled: false,
      };
    case "GET_LIST_USER_REJECTED":
      return {
        ...state,
        isLoading: false,
        isRejected: true,
        errorMessage: action.payload.response.data ?? null,
      };
    case "GET_LIST_USER_FULFILLED":
      return {
        ...state,
        isLoading: false,
        isFulfilled: true,
        count: action.payload.response.data?.count ?? 0,
        data: action.payload.response.data?.result ?? null,
      };
    default:
      return state;
  }
};
